<template>
  <!-- 头像 -->
  <div class="w-34px h-34px rounded-full select-none user-avatar">
    <SvgIcon name="ic-avatar" width="20px" height="20px"></SvgIcon>
  </div>
  <el-dropdown class="m-l-10px" :hide-on-click="false" @command="handleCommand">
    <div class="index-dropdown">
      <div class="max-w-113px text-14px m-r-6px line-clamp-1 text-align-center">{{ userInfo.rname }}</div>
      <div class="max-w-113px text-12px m-r-6px line-clamp-1 text-align-center bg-#19be6b rd p-r-5px p-l-5px">
        {{ getRoleName() }}
      </div>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="lcMine">个人中心</el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { lcSessionStorage, lcLocalStorage } from "@/utils/storage";
import { useRouter } from "vue-router";
import useUserStore from "@/stores/modules/user";
import { storeToRefs } from "pinia";
import { LOGIN_URL } from "@/config";
const router = useRouter();
const userStore = useUserStore();
const { userInfo } = storeToRefs(userStore);

// 获取角色名称
const getRoleName = () => {
  const { role } = userInfo.value;
  if (!role) {
    return "普通用户";
  } else {
    return "管理员";
  }
};

// 退出登录
const handleLayout = () => {
  lcSessionStorage.clear();
  lcLocalStorage.clear();
  // 必须使用这个把页面缓存刷掉
  window.location.replace(LOGIN_URL);
  window.close();
};

// 下拉折叠
const handleCommand = (command: string | number) => {
  switch (command) {
    case "lcMine":
      router.push("/system/personage");
      break;
    case "logout":
      handleLayout();
      break;
  }
};
</script>

<style lang="scss" scoped>
// dropdown字体颜色
.index-dropdown {
  color: var(--el-header-text-color);
  // white-space: nowrap; /* 不换行 */
  cursor: pointer;
  outline: none; // 去除伪元素
  // display: flex;
  line-height: 20px;
  align-items: center;
}
</style>
